import * as React from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { Row, Col } from "react-flexbox-grid";
import { ILocalization } from "../../../models/localization";
import { OpportunityViewState, ScreenMode, AddExpRoute } from "../../../models/enums";
import { Prereq, SkillSet, SetSkill } from "../../../models/opportunity";
import OpportunityStore from "../../../stores/opportunityStore";
import AddExperienceVw from "../../../views/addExperience";
import { SavedOpportunity, ExperienceSkill, ProfileSkill, Profile, SkillFit } from "../../../models/profile";
import ProficiencyIndicator from "../../widgets/Indicator";
import UpdateSkill from "../updateSkill";
import CCLCEditor from "../../profile/cclcEditor";
import { PrereqEditor } from "../../profile/prereqEditors";
import Paper from "material-ui/Paper";
import scrollToComponent from 'react-scroll-to-component';
import ScoringEngine from "../../../utils/scoring";
import BuildIt from "../buildIt";
import { CourseOffering } from "../../../models/education";
import * as s from "./skills.css";

interface IParams {
  opId: string;
}

@observer
export class PrerequisiteSkills extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  @observable selPrereq: Prereq;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
    this.selPrereq = null;
  }
  @action setPrereq = (p: Prereq): void => {
    if (p === this.selPrereq) {
      this.selPrereq = null;
    } else {
      this.selPrereq = p;
    }
  }
  @action clearSelectedPrereq = (): void => {
    this.selPrereq = null;
  }
  renderPrerequisites(): JSX.Element[] {
    const local: ILocalization = this.props.store.localization.fields;
    let items: JSX.Element[] = [];
    let flag: boolean = false;

    this._opStore.selectedOp.prereqs.map((p: Prereq, i: number) => {
      flag = this._opStore.prereqFulfilled(p);
      items.push(<Row middle="xs" key={"prereq-skill" + i} >
        <Col xs={3} md={4} className={s.skillIcon}>
          {flag ? <img src={local.icons.greenCheck} /> : <img src={local.icons.xSign} />}
        </Col>
        <Col xs={6} >
          <p>{p.title}</p>
        </Col>
        {<Col xs={2}>
          <a onClick={() => this.setPrereq(p)} className={s.smallText}>{this.selPrereq === p ? local.close : local.opportunity.more}</a>
        </Col>}
        {this.selPrereq === p && <Col xsOffset={1} xs={10}><PrereqEditor store={this.props.store} prereq={p} clear={this.clearSelectedPrereq} /></Col>}
      </Row>)
    })
    if (items.length === 0) {
      items.push(<p key="prereq-skill-list" className={s.center}>{local.opportunity.noPrereqs}</p>);
    }
    return items;
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<div className={s.skillsTextWrapper}>
      <h6 className={s.skillHeader}>{local.prereqs}</h6>
      <div>
        {this.renderPrerequisites()}
      </div>
    </div>)
  }
}

@observer
export class RequiredSkills extends React.Component<{ store: SeekerStore, params: IParams, update?: () => void }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;

  }
  @action onChange = (skill: SetSkill): void => {
    this.props.store.opportunityStore.setSelectedSetSkill(skill);
    this.props.store.opportunityStore.setViewState(OpportunityViewState.SkillsView);
  }

  @action showBuild = (skill: SetSkill): void => {
    this.props.store.opportunityStore.setSelectedSetSkill(skill);
    this.props.store.opportunityStore.setViewState(OpportunityViewState.BuildView);
  }
  renderRequiredSkills(a: number, b: number): JSX.Element[] {
    const local: ILocalization = this.props.store.localization.fields;
    let requiredSkills: Array<SetSkill> = [];
    requiredSkills = this._opStore.selectedOp.requiredSkills() || [];
    let items: JSX.Element[] = [];
    const savedOp: SavedOpportunity = this.props.store.profileStore.getSavedOpportunity(this._opStore.selectedOp.idHash);
    requiredSkills.map((r: SetSkill, i: number) => {
      const showBuild: boolean = this.props.store.educationStore.courseMatch(r.skillId);
      const sf: SkillFit = savedOp && savedOp.skillFit.find((f: SkillFit): boolean => { return f.skill === r.skillId; });
      if (sf) {
        items.push(<Row middle="xs" key={"required-skill-" + i}><Col xs={a} className={s.proficiencyCol} ><ProficiencyIndicator indicator={r.level} usage={sf.level} /></Col><Col xs={6} className={s.skillPadding}><a className={s.titleLink} onClick={() => this.onChange(r)}>{r.title}</a></Col><Col xs={b} className={s.buildCol}><a onClick={() => this.showBuild(r)} className={s.smallText}>{showBuild ? local.opportunity.build : null}</a></Col></Row>)
        return;
      }
      else {
        items.push(<Row middle="xs" key={"required-skill-" + i}><Col xs={a} className={s.proficiencyCol} ><ProficiencyIndicator indicator={r.level} usage={0} /></Col><Col xs={6} className={s.skillPadding}><a className={s.titleLink} onClick={() => this.onChange(r)}>{r.title}</a></Col><Col xs={b} className={s.buildCol}><a onClick={() => this.showBuild(r)} className={s.smallText}>{showBuild ? local.opportunity.build : null}</a></Col></Row>)
      }
    })

    if (items.length === 0) {
      items.push(<p key="required-skill-list" className={s.center}>{local.opportunity.noRequired}</p>);
    }

    return items;
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<div className={s.skillsTextWrapper}>
      <h6 className={s.skillHeader}>{local.requiredSkills}</h6>
      {mode !== ScreenMode.Tablet && this.renderRequiredSkills(3,3)}
      {mode === ScreenMode.Tablet && this.renderRequiredSkills(4,2)}
    </div>)
  }
}

@observer
export class DesiredSkills extends React.Component<{ store: SeekerStore, params: IParams }, {}> {

  private _opStore: OpportunityStore;

  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  @action onChange = (skill: SetSkill): void => {
    this.props.store.opportunityStore.setSelectedSetSkill(skill);
    this.props.store.opportunityStore.setViewState(OpportunityViewState.SkillsView);
  }

  @action showBuild = (skill: SetSkill): void => {
    this.props.store.opportunityStore.setViewState(OpportunityViewState.BuildView);
    this.props.store.opportunityStore.setSelectedSetSkill(skill);
  }

  renderDesiredSkills(a: number, b: number): JSX.Element[] {
    const local: ILocalization = this.props.store.localization.fields;
    let desiredSkills: Array<SetSkill> = this._opStore.selectedOp.desiredSkills() || [];
    let items: JSX.Element[] = [];
    const savedOp: SavedOpportunity = this.props.store.profileStore.getSavedOpportunity(this._opStore.selectedOp.idHash);

    desiredSkills.map((d: SetSkill, i: number) => {
      const showBuild: boolean = this.props.store.educationStore.courseMatch(d.skillId);
      const sf: SkillFit = savedOp && savedOp.skillFit.find((f: SkillFit): boolean => { return f.skill === d.skillId; });
      if (sf) {
        items.push(<Row middle="xs" key={"des-skill-" + i}><Col xs={a} className={s.proficiencyCol}><ProficiencyIndicator indicator={d.level} usage={sf.level} /></Col><Col xs={6} className={s.skillPadding}><a onClick={() => this.onChange(d)} className={s.titleLink} >{d.title}</a></Col><Col xs={b} className={s.buildCol} ><a className={s.smallText} onClick={() => this.showBuild(d)} >{showBuild ? local.opportunity.build : null}</a></Col></Row>)
        return;
      }
      else {
        items.push(<Row middle="xs" key={"des-skill-" + i}><Col xs={a} className={s.proficiencyCol}><ProficiencyIndicator indicator={d.level} usage={0} /></Col><Col xs={6} className={s.skillPadding}><a onClick={() => this.onChange(d)} className={s.titleLink} >{d.title}</a></Col><Col xs={b} className={s.buildCol} ><a className={s.smallText} onClick={() => this.showBuild(d)} >{showBuild ? local.opportunity.build : null}</a></Col></Row>)
      }
    })

    if (items.length === 0) {
      items.push(<p key="desired-skill-list" className={s.center} >{local.opportunity.noDesired}</p>);
    }
    return items;
  }


  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<div className={s.skillsTextWrapper}>
      <h6 className={s.skillHeader}>{local.desiredSkills}</h6>
      {mode !== ScreenMode.Tablet && this.renderDesiredSkills(3, 3)}
      {mode === ScreenMode.Tablet && this.renderDesiredSkills(4, 2)}
    </div>)
  }
}


@observer
export class OpSkills extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<Col xs={12} >
      <Paper elevation={4} className={s.paper}>
        <Row>
          <Col xsOffset={1} xs={10} smOffset={2} sm={8} >
            <h4 className={s.header}>{local.opportunity.opSkillsHeader}</h4>
            <hr />
          </Col>
        </Row>
        {mode === ScreenMode.Tablet && < Row >
          <Col xs={12} smOffset={1} sm={10} lg={4} ><PrerequisiteSkills store={this.props.store} params={this.props.params} /></Col>
          <Col xs={12} smOffset={1} sm={10} lg={4} className={s.greyBackground} ><RequiredSkills store={this.props.store} params={this.props.params} /></Col>
          <Col xs={12} smOffset={1} sm={10} lg={4} ><DesiredSkills store={this.props.store} params={this.props.params} /></Col>
        </Row>}
        {mode !== ScreenMode.Tablet && < Row className={s.skillsContainer}>
          <Col xs={12} sm={12} lg={4} ><PrerequisiteSkills store={this.props.store} params={this.props.params} /></Col>
          <Col xs={12} sm={12} lg={4} className={s.greyBackground}><RequiredSkills store={this.props.store} params={this.props.params} /></Col>
          <Col xs={12} sm={12} lg={4} ><DesiredSkills store={this.props.store} params={this.props.params} /></Col>
        </Row>}
        {this.props.store.opportunityStore.viewState === OpportunityViewState.SkillsView && <UpdateSkill store={this.props.store} />}
        {this.props.store.opportunityStore.viewState === OpportunityViewState.BuildView && <BuildIt store={this.props.store} />}
      </Paper></Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/skills/index.tsx